(function($) {


    function init_popup(){
        var sendData = {
            action: 'emergency_popup',
            post_id: $('.emergency_popup').attr('data-post'),
            category_id: $('.emergency_popup').attr('data-category')
        };

        $.ajax({
            url: ajaxadminurl.ajaxurl,
            type: 'POST',
            data: sendData,
            dataType: 'html',
            cache: false,
            timeout: 10000,

            success: function(data, textStatus, jqXHR) {
                $('.emergency_popup').html(data);

                if( $('.emergency_popup_shadow').length == 0 ){
                    $('body').append('<div class="emergency_popup_shadow"></div>');
                }

                if(data.length){
                    $('.emergency_popup, .emergency_popup_shadow').fadeIn();
                } else {
                    $('.emergency_popup, .emergency_popup_shadow').remove();
                }
                $('.emergency_popup_content').addClass('fade');
            },
            error:  function(data, textStatus, jqXHR){
                console.log('error');
                console.log(data);
            }
        });

    }

    $(document).on('click', '.emergency_popup .close', function(e){
        e.preventDefault();
        $(this).closest('.emergency_popup').add('.emergency_popup_shadow').fadeOut();

        setTimeout(function(){
            init_popup();
        },3000);
        return false;
    });

    $(document).ready(function(){
        setTimeout(function(){
            init_popup();
        },3000);
    });

})( jQuery );


